import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'


Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        meetingData: {},
        registrantData: {
            regType: {
                price: ''
            },
            btlWorkshop: false,
            firstName: '',
            lastName: '',
            primaryDegree: '',
            attendeeEmail: '',
            phoneNumber: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            country: '',
            zip: '',
            howDidYouHear: '',
            referExtra: '',
            howManyYears: '',
            guests: '0',
            guestTotal: '0',
            total: '0',
            medicalExtraData: {
                medicalSpecialty: '',
                medicalLicenseNumber: '',
                medicalLicenseExpirationDate: '',
                numberOfYearsPracticing: ''
            },
            traineeExtraData: {
                traineeType: '',
                medicalSpecialty: '',
            },
            industryExtraData: {
                companyName: '',
            },
            oneDayExtraData: {
                day: ''
            },
            staffBundleExtraData: {
                firstName: '',
                lastName: '',
                primaryDegree: '',
                attendeeEmail: '',
                phoneNumber: '',
                positionInPractice: '',
            },
            promoCode: '',
            promoData: {},
            promoReferEmail: '',
            promoReferEmailRequired: false,
            freeRegEligibiltyRequired: false,
            ccInfo: {
                number: '',
                firstName: '',
                lastName: '',
                type: '',
                expiry: '',
                cvv: '',
                zip: ''
            },
            terms: false,
            completeSections: [],
            selectedRegType: '',
            proof: {},
            ownPractice:'',
            practiceName:''
        },
        showSection: {
            trainee: false,
            oneDay: false,
            medical: false,
            industry: false
        },
        loading: false,
        formstate: {
            staffBundle: {},
            trainee: {},
            oneDay: {},
            medical: {},
            register: {},
            terms: false,
            signature: '',
            reg_eligibilty: false,
        },
        response: {},
    },
    getters: {
        getState(state) {
            return state;
        }
    },
    mutations: {
        addBTLWorkshop(state) {
            state.registrantData.btlWorkshop = true;
        },
        setInitialState(state, newState) {
            let formatRegTypesForCurrency = newState.reg_type.filter((item) => {
                item.price = parseInt(item.price).toFixed(2);
                return item;
            });
            state.meetingData = newState;
            state.meetingData.guest = parseInt(state.meetingData.guest).toFixed(2);
            state.meetingData.reg_type = formatRegTypesForCurrency;
        },
        lookupPromoCode(state, promoResponse) {
            state.registrantData.promoData = promoResponse;
            if (state.registrantData.promoData.Code.state === "fail"){
                alert(state.registrantData.promoData.Code.msg);
            }
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        sendRequest(state, response) {
            state.response = response;
            console.log(response);
        },
        updateTotal(state) {

            state.registrantData.selectedRegType = state.meetingData.reg_type.filter((regType) => {
                if (regType.id === state.registrantData.regType) {
                    return regType
                }
            });
            if (state.meetingData.earlybird === 'true') {
                state.registrantData.regType.price = parseInt(state.registrantData.regType.earlybirdPrice).toFixed(2);
            } else {
                state.registrantData.regType.price = parseInt(state.registrantData.regType.regularPrice).toFixed(2);
            }
            let promoTotal = 0;

            if (state.registrantData.promoData.referdiscount && state.registrantData.promoCode !== '') {
                promoTotal = state.registrantData.promoData.referdiscount

            }
            // let preConTotal = 0;
            // for (let i = 0; i < state.registrantData.preConferenceCourses.length; i++) {
            //     preConTotal += parseInt(state.registrantData.preConferenceCourses[i].price);
            // }


                if (state.registrantData.promoData.type === 'percentage' && state.registrantData.promoCode !== ''){

                    let percentage = state.registrantData.promoData.referdiscount/100;
                    state.registrantData.total = parseInt(state.registrantData.regType.price) - parseInt(state.registrantData.regType.price)*percentage;
                } else {
                    state.registrantData.total = parseInt(state.registrantData.regType.price) - parseInt(promoTotal);
                }



            state.registrantData.total = state.registrantData.total.toFixed(2);


        },
        addProof(state, file) {
            state.registrantData.proof = file;
        },
        updateRegType(state, reg) {

            state.registrantData.regType = reg;


        },
        removePromoVal(state) {
            state.registrantData.promoCode = '';
        },
        makePromoReferEmailRequired(state) {
            state.registrantData.promoReferEmailRequired = true;
        },
        makePromoReferEmailNotRequired(state) {
            state.registrantData.promoReferEmailRequired = false;
        },
        makeFreeRegEligibiltyRequired(state) {
            state.registrantData.freeRegEligibiltyRequired = true;
        },

    },
    actions: {
        setInitialState(context) {
            context.commit('setLoading', true);
            axios.get('https://www.cosmeticfrontiers.com/api/2026/meeting/')
                .then((response) => {
                    context.commit('setInitialState', response.data)
                    context.commit('setLoading', false)
                })
        },
        lookupPromoCode(context) {
            let apiConfig = {
                data: {},
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                method: 'post',
                url: 'https://www.cosmeticfrontiers.com/api/2026/meeting/code.php',
            };

            let params = new URLSearchParams();
            params.append('Code', context.state.registrantData.promoCode);
            params.append('Type', context.state.registrantData.regType.type);
            apiConfig.data = params;
            axios(apiConfig).then(
                response => {
                    context.commit('lookupPromoCode', response.data);
                    context.commit('updateTotal');
                }
            ).catch(
                error => {
                    alert(error);
                }
            );
        },
        sendRequest(context) {
            context.state.registrantData.ccInfo.type = getCardType(context.state.registrantData.ccInfo.number.replace(' ', ''));
            context.commit('setLoading', true);

            var apiConfig;

            var data = new FormData();

            apiConfig = {
                data: {},
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                method: 'post',
                url: 'https://www.cosmeticfrontiers.com/api/2026/meeting/register.php',
            };

            if (context.state.registrantData.regType.combinedName == 'FCPT' || context.state.registrantData.regType.combinedName == 'ODPT') {
                data.append('proof', context.state.registrantData.proof, context.state.registrantData.proof.name);
                apiConfig = {
                    data: {},
                    headers: {
                        'accept': 'application/json',
                        'Accept-Language': 'en-US,en;q=0.8',
                        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
                    },
                    method: 'post',
                    url: 'https://www.cosmeticfrontiers.com/api/2026/meeting/register.php',
                };
            }


            let toSend = context.state.registrantData;

            data.append('register', JSON.stringify(toSend));
            apiConfig.data = data;

            axios(apiConfig).then(
                response => {
                    context.commit('sendRequest', response.data);
                    context.commit('setLoading', false);
                    if (response.data.transactionStatus == "Approved") {

                    }
                }
            ).catch(
                error => {
                    alert(error);
                }
            );
        }
    }
})

function getCardType(cardNum) {

    if (!luhnCheck(cardNum)) {
        return "";
    }
    var payCardType = "";
    var regexMap = [
        {regEx: /^4[0-9]{5}/ig, cardType: "VISA"},
        {regEx: /^5[1-5][0-9]{4}/ig, cardType: "MASTERCARD"},
        {regEx: /^3[47][0-9]{3}/ig, cardType: "AMEX"},
        {regEx: /^(5[06-8]\d{4}|6\d{5})/ig, cardType: "MAESTRO"}
    ];

    for (var j = 0; j < regexMap.length; j++) {
        if (cardNum.match(regexMap[j].regEx)) {
            payCardType = regexMap[j].cardType;
            break;
        }
    }

    if (cardNum.indexOf("50") === 0 || cardNum.indexOf("60") === 0 || cardNum.indexOf("65") === 0) {
        var g = "508500-508999|606985-607984|608001-608500|652150-653149";
        var i = g.split("|");
        for (var d = 0; d < i.length; d++) {
            var c = parseInt(i[d].split("-")[0], 10);
            var f = parseInt(i[d].split("-")[1], 10);
            if ((cardNum.substr(0, 6) >= c && cardNum.substr(0, 6) <= f) && cardNum.length >= 6) {
                payCardType = "RUPAY";
                break;
            }
        }
    }
    return payCardType;

}

function luhnCheck(cardNum) {
    // Luhn Check Code from https://gist.github.com/4075533
    // accept only digits, dashes or spaces
    var numericDashRegex = /^[\d\-\s]+$/
    if (!numericDashRegex.test(cardNum)) return false;

    // The Luhn Algorithm. It's so pretty.
    var nCheck = 0, nDigit = 0, bEven = false;
    var strippedField = cardNum.replace(/\D/g, "");

    for (var n = strippedField.length - 1; n >= 0; n--) {
        var cDigit = strippedField.charAt(n);
        nDigit = parseInt(cDigit, 10);
        if (bEven) {
            if ((nDigit *= 2) > 9) nDigit -= 9;
        }

        nCheck += nDigit;
        bEven = !bEven;
    }

    return (nCheck % 10) === 0;
}


